// The calendar's backdrop is one wide seasonal panorama (public/images/seasons.webp),
// seen a sixth at a time. Its seasons run right-to-left like the app: spring at
// the right edge, then summer, autumn and winter, with spring again at the left
// edge so the image tiles seamlessly.
//
// Each month steps one twelfth of the image width further left. Neighbouring
// months therefore share half of what they show, and a year reads as one slow
// pan; twelve steps cover the whole image and land back on فروردین.

// The month slide paints the image six container-widths wide, so it overhangs
// the container by five. A background-position of P% shifts it by -5W * P/100,
// which puts the right end at 100% and makes every ten points a step of half a
// container — one twelfth of the image.
const STEP = 10

// Gregorian months are shifted so each one lands on the season it shares with
// the Jalaali month it overlaps (April ≈ فروردین).
const seasonIndex = (month: number, system: 'jalaali' | 'gregorian') =>
    system === 'gregorian' ? (month + 8) % 12 : month - 1

// Where this month sits along the panorama, as a background-position-x.
// اسفند lands on -10%, running past the image's left edge into the repeat —
// which is the first month's frame again.
export const monthBackgroundX = (month: number, system: 'jalaali' | 'gregorian') =>
    `${100 - STEP * seasonIndex(month, system)}%`
